const STORAGE_KEY = 'mobileApplicationDraft';
const TERMS_RETURN_KEY = 'mobileTermsFromApplication';

export function markTermsOpenedFromApplication() {
  if (typeof window === 'undefined') return;
  sessionStorage.setItem(TERMS_RETURN_KEY, '1');
}

export function clearTermsOpenedFromApplication() {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(TERMS_RETURN_KEY);
}

export function isTermsOpenedFromApplication() {
  if (typeof window === 'undefined') return false;
  return sessionStorage.getItem(TERMS_RETURN_KEY) === '1';
}

export function loadMobileApplicationDraft() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveMobileApplicationDraft(draft) {
  if (typeof window === 'undefined') return;
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(draft));
}

export function clearMobileApplicationDraft() {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(STORAGE_KEY);
  clearTermsOpenedFromApplication();
}

export function acceptTermsInDraft() {
  const draft = loadMobileApplicationDraft();
  if (!draft?.shared) return;
  saveMobileApplicationDraft({
    ...draft,
    step: 4,
    shared: { ...draft.shared, hyvaksyKayttoehdot: true },
  });
}

export function declineTermsInDraft() {
  const draft = loadMobileApplicationDraft();
  if (!draft?.shared) return;
  saveMobileApplicationDraft({
    ...draft,
    step: 1,
    shared: { ...draft.shared, hyvaksyKayttoehdot: false },
  });
}
